export function ComponentDownloads() {
  $('.section-download form').on('submit', function (e) {

    var email = $(this).find('input[type="email"]').val();
    var filename = $(this).find('input[name="filename"]').val();
    
    if (email == '') {
      e.preventDefault();
      $('.download-alert').removeClass('d-none');
    } else {
      $('.download-alert').addClass('d-none');
      $.post({
        dataType: "json",
        url: WP.ajax_url,
        data: {'action': 'maildownload', 'email': email, 'filename': filename}
      });
    }
  });
}
